<template>
  <i-input
    search
    :value="value || values"
    :placeholder="placeholder?placeholder:$t('Common-search-item0')"
    @on-change="onInputChange"
    @on-search="search"
    style="width: 200px"
  />
</template>
<script>
export default {
  name: 'SearchItem',
  data () {
    return {
      values: ''
    }
  },
  props: ['placeholder', 'value'],
  methods: {
    onInputChange (e) {
      this.values = e.currentTarget.value;
      this.$emit('input', this.values);
    },
    search: function () {
      this.$emit('accept-keys', this.value || this.values);
    }
  }
}
</script>
